import { render } from "./ProgressBar.vue?vue&type=template&id=000b2a98&scoped=true&ts=true"
import script from "./ProgressBar.vue?vue&type=script&lang=ts"
export * from "./ProgressBar.vue?vue&type=script&lang=ts"

import "./ProgressBar.vue?vue&type=style&index=0&id=000b2a98&scoped=true&lang=css"

import exportComponent from "/home/runner/work/owt/owt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-000b2a98"]])

export default __exports__